module.exports = __webpack_public_path__ + "img/th-top-bg.4d6331fd.png";